<template>

    <div class="card mb-3">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <p class="font-weight-bold text-success"> <i class="bi bi-patch-check-fill"></i> {{__('messages.the_best_price')}} </p>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p class="medium-text">
                        {{__('messages.the_best_price_description')}}
                        <a v-if="culture.internalCultureCode === 'es-mx'" :href="__('url.url_best_price')" class="link link--md" target="_blank">{{__('messages.more_information')}}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    const site = window.__pt.settings.site;
    const culture = window.__pt.cultureData;
    export default {
        data() {
            return {
                siteConfig: site,
                culture
            };
        },
        async mounted() {
        },
        methods: {

        },
        components: {

        }
    }
</script>
